import avatarSvg from 'assets/image/icons/svg/user.svg'
import linkSvgGold from 'assets/image/icons/tables/goldLink.svg'
import inIcon from 'assets/image/icons/tables/in.svg'
import clsx from 'clsx'
import { CustomTip } from 'components/atoms/tooltipCustom'
import { typo } from 'shared/styles'
import { ordinalNumber } from 'shared/utils'

import { CellTooltip } from '../CellTooltip'
import tableCSS from './ContactsTable.module.css'
import css from './NameCell.module.css'

export function NameCell({
	avatar,
	distance = 0,
	fullName = '',
	isPremium = false,
	linkedinId = ''
}: {
	avatar?: string
	distance?: number
	fullName?: string
	isPremium?: boolean
	linkedinId?: string
}) {
	return (
		<th className={clsx(css.root, tableCSS.cell, typo.buttonSm)}>
			<img
				alt={`Photo of ${fullName}`}
				className={css.avatar}
				height={32}
				src={avatar ?? avatarSvg}
				style={{
					backgroundImage: `url(${avatarSvg})`
				}}
				width={32}
			/>

			<span className={css.name}>{fullName}</span>
			{distance && ` • ${ordinalNumber(distance)}`}
			{isPremium && (
				<CustomTip arrow title='Premium profile'>
					<img alt='premium' src={inIcon} />
				</CustomTip>
			)}
			{linkedinId && (
				<CellTooltip content='Open LinkedIn profile'>
					<a
						className='link-container-ln'
						href={`https://www.linkedin.com/in/${linkedinId}/`}
						rel='noopener noreferrer'
						target='_blank'
					>
						<img alt='link svg' src={linkSvgGold} />
					</a>
				</CellTooltip>
			)}
		</th>
	)
}
